/* Keep catalog searches precise; broader discovery remains an explicit choice. */
(function () {
  const fields = ['title', 'vendor', 'product_type', 'variants.sku', 'variants.barcode'];
  function catalogQuery(value) {
    const terms = value.trim().split(/\s+/).filter(Boolean);
    // Preserve advanced syntax and single-word typo-tolerant discovery.
    if (terms.length < 2 || /[":()\\*]|\b(?:AND|OR|NOT)\b/.test(value) || terms.some(term => term.startsWith('-'))) return value.trim();
    return terms.map(term => '(' + fields.map(field => `${field}:"${term}"`).join(' OR ') + ')').join(' AND ');
  }

  function displayQuery(value) {
    if (!value.startsWith('(title:') || !value.includes(' OR vendor:')) return value;
    return value.split(') AND (').map(part => part.split(' OR ')[0].replace(/^\(?title:/, '').replace(/["*]/g, '')).join(' ');
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { catalogQuery, displayQuery };
  if (typeof document === 'undefined') return;
  window.MediaMallSearch = { catalogQuery, displayQuery };

  document.addEventListener('submit', event => {
    const form = event.target;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || new URL(form.action, location.href).pathname !== window.routes.search_url) return;
    if (form.closest('predictive-search')?.querySelector('[aria-selected="true"] a')) return;
    const query = catalogQuery(input.value);
    if (!query) return;
    event.preventDefault();
    const url = new URL(form.action, location.href);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'last');
    location.assign(url.href);
  }, true);

  // Also repair bookmarked/shared plain-query search URLs, before filtering/pagination.
  if (document.body.classList.contains('template-search')) {
    const url = new URL(location.href);
    const original = url.searchParams.get('q') || '';
    const broad = url.searchParams.get('mm_broad') === '1';
    const query = catalogQuery(original);
    if (!broad && query !== original.trim()) {
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.delete('page');
      location.replace(url.href);
      return;
    }
    if (broad) {
      const form = document.getElementById('FacetsFilterForm');
      if (form) {
        const flag = document.createElement('input');
        flag.type = 'hidden'; flag.name = 'mm_broad'; flag.value = '1';
        form.appendChild(flag);
      }
    }
  }
})();
